import React, { useCallback, useState } from "react";
import styles from "./catalog-layout.module.scss";
import { MenuCategories } from "../menu/MenuCategories";
import { FooterElement } from "../footer-element/FooterElement";
import { LayoutTypes, useLayoutType } from "@/util-react/layout";
import { ParametersDialog } from "@/elements-react/parameters-dialog/ParametersDialog.tsx";
import { useEffect } from "preact/hooks";
import { useServices } from "@/services-context.tsx";
import { PARAMETERS_LISTENER_NAME } from "@/services/parameters.ts";
import { googleEvent } from "@/helpers/google-events.ts";
import { DocumentElements } from "../document-elements/document-elements";
import WhatsAppIcon from "@/elements-react/whatsapp-icon";
import {Header} from "@/elements-react/catalog-layout/header";
import { Templates, useTemplate } from "@/util-react/template";

// SSR-safe: do not use window/document outside effects

export const CatalogLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const layoutType = useLayoutType();
  const services = useServices([PARAMETERS_LISTENER_NAME]);

  const [popup, setPopup] = useState<null | { target: any; type: "menu-lg" | "menu-sm" | "menu-categories" | "parameters" }>(null);
  // TODO: get parameters from services if needed

  // SSR-safe anchor ref
  const setCountryElementRef = React.useCallback((element?: Element) => setCountryElement(element ?? null), []);
  const [countryElement, setCountryElement] = useState<Element | null>(null);

  useEffect(() => {
    if (services.parameters.checkIsDialogNeeded()) {
      if (layoutType.layoutType === LayoutTypes.TYPE_MOBILE) {
        setPopup({ type: "parameters", target: null });
      } else if (countryElement) {
        setPopup({ type: "parameters", target: countryElement });
      }
    }
  }, [countryElement, layoutType.layoutType]);

  // TODO: get parameters.dialogVisible from services if needed
  const getPopup = useCallback(() => popup, [popup]);

  const openPopup = (type: "menu-lg" | "menu-sm" | "menu-categories" | "parameters", target: any) => {
    setPopup({ type, target });
  };
  const closePopup = () => {
    services.parameters.setDialogVisible(false);
    services.parameters.setDialogProposed(true);
    setPopup(null);
  };

  // TODO: Do something with that stub?
  // Desktop and mobile heads are stubs for now
  const renderDesktop = () => (
    <div style={{ display: "contents" }}>
      <DocumentElements />
      {getPopup() && renderPopup()}
      <div className={styles.container}>
        <Header
          countryElementRefCallback={setCountryElementRef}
          onCategoryClick={(e) => {
            googleEvent("product_category_click");
            openPopup("menu-categories", e?.currentTarget);
          }}
          onMenuClick={(e) => openPopup("menu-lg", e?.currentTarget)}
        />
        {children}
        <FooterElement />
        <WhatsAppIcon />
      </div>
    </div>
  );
  const renderMobile = () => (
    <div style={{ display: "contents" }}>
      <DocumentElements />
      {getPopup() && renderPopup()}
      <div className={styles.container}>
        <Header onMenuClick={(e) => openPopup("menu-sm", e?.target)} />
        {children}
        <FooterElement />
        <WhatsAppIcon />
      </div>
    </div>
  );
  function renderPopup() {
    const p = getPopup();
    if (!p) return null;
    switch (p.type) {
      case "menu-categories":
        return <MenuCategories anchor={p.target} onClose={closePopup} />;
      case "parameters":
        return <ParametersDialog anchor={p.target} type={layoutType.layoutStyleType} onClose={closePopup} />;
      default:
        return null;
    }
  }

  return layoutType.layoutType === LayoutTypes.TYPE_DESKTOP ? renderDesktop() : renderMobile();
};
